import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const MyContractsIcon: React.FC<SvgProps> = ({ strokeColor = 'white' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.251 17.4074V29.333H2.66669V2.80664H23.251V13.6439"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.21735 6.97852H19.7005"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.21735 10.7422H19.7005"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.21735 14.5508H17.7679"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.21735 18.3145H16.0151"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6554 23.5285L17.588 25.1609L18.0375 22.531L29.0487 3.89453L30.6667 4.8921L19.6554 23.5285Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37469 22.2598C7.5657 24.527 7.61065 25.1618 7.83537 25.2071C8.41964 25.3885 10.3522 22.4411 11.2511 22.5772C12.0601 22.7132 11.1612 25.2525 12.0151 25.3885C12.7342 25.4792 13.8578 23.8468 14.3972 24.0735C14.8017 24.2549 14.3522 25.1618 14.7567 25.7059C15.0713 26.1594 15.7455 26.0687 16.3747 25.9326"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MyContractsIcon;
